import { bindActionCreators } from 'redux';
import idx from 'idx';
import partial from 'lodash/partial';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { vote } from 'focus_groups/ducks/vote';
import VotingFormTile from 'focus_groups/components/voting_form_tile';

const mapDispatchToProps = (dispatch, { id, params }) => {
  const { focusGroupId, participantKey } = params;

  return bindActionCreators({
    vote: partial(vote, participantKey, focusGroupId, id),
  }, dispatch);
}

export default withRouter(connect(undefined, mapDispatchToProps)(VotingFormTile));



// WEBPACK FOOTER //
// ./focus_groups/containers/voting_form_tile.js